import { Link } from "react-router-dom";

export default function PaymentFailed() {
  return (
     <>
    <div className="h-screen overflow-auto flex bg-white">
     <div className="w-full m-auto">
        <div className="max-w-[600px] mx-auto p-5">
            <img src="/assets/img/failed.png" className="w-[200px] object-conatin mx-auto"/>
            <div className="space-y-2 mt-8">
          <h2 className="text-xl font-semibold text-[#DD0000] text-center">Payment Failed </h2>
          <h3 className="text-sm text-[#464646] text-semibold text-center">We couldn’t process your payment. </h3>
                    <p className="text-sm text-[#777777] text-center">
            Something went wrong while completing your transaction. This could be due to a network issue, insufficient funds, or your bank declining the payment.
          </p>
          </div>
        <div className="flex items-center justify-center flex-wrap gap-4 mt-8">
         <Link to="/">
          <button className="bg-[linear-gradient(45deg,#115B9D,#116DAE)] text-sm font-[600] text-gray-600 border rounded-full shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed p-[2px]">
            <span className="flex items-center justify-center gap-2 rounded-full bg-white h-10 hover:opacity-80 !px-8">Back to Home</span>
          </button>
          </Link>
          <button className="bg-[linear-gradient(45deg,#115B9D,#116DAE)] text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 rounded-full shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed !px-8">
           Try Again
          </button>
        </div>
        </div>
     </div>
    </div>
    </>
  )
}
